import { SMLRouteNames } from '../../routing/sml/SMLRoutes';
import type { DirectedWizardStep } from './directedSteps';

/** The part of the route after the song: `/catalog/song/<uuid>/directed-video[/<video uuid>]`. */
export const DIRECTED_VIDEO_SEGMENT = 'directed-video';

export interface DirectedVideoPathOptions {
  /** The artist of the song; the web switcher reads it. */
  accountId?: number | null;
  /** The page that opened the wizard (a path inside the app): "Song" returns to it. */
  from?: string | null;
  /** An earlier step to look at again (`?step=`). With none, the step comes from the status. */
  step?: DirectedWizardStep | null;
  /** `made`: "How it was made" of a video whose make started (design l1, `?view=made`). */
  view?: 'made' | null;
}

/**
 * The path of the directed video wizard of one song (design directed-video b1):
 * `/catalog/song/<uuid>/directed-video[/<directed video uuid>][?accountId=][&from=][&step=]`. The
 * router adds `/app`. With no video uuid the wizard opens the open directed video of the song, or
 * makes a new one, and puts its uuid in the URL. So reload, Back and a shared link work.
 */
export function directedVideoPath(
  catalogItemUuid: string,
  directedVideoUuid?: string | null,
  options: DirectedVideoPathOptions = {}
): string {
  const query = new URLSearchParams();
  if (options.accountId !== undefined && options.accountId !== null) {
    query.set('accountId', String(options.accountId));
  }
  if (options.from !== undefined && options.from !== null && options.from !== '') {
    query.set('from', options.from);
  }
  if (options.view === 'made') {
    query.set('view', 'made');
  }
  if (options.step !== undefined && options.step !== null) {
    query.set('step', options.step);
  }
  const search = query.toString();
  const video =
    directedVideoUuid === undefined || directedVideoUuid === null || directedVideoUuid === ''
      ? ''
      : `/${encodeURIComponent(directedVideoUuid)}`;
  return `/${SMLRouteNames.catalog}/song/${encodeURIComponent(catalogItemUuid)}/${DIRECTED_VIDEO_SEGMENT}${video}${
    search === '' ? '' : `?${search}`
  }`;
}
